module.exports = __webpack_public_path__ + "static/img/image_news_over_03.e1b3a87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/news/image_news_over_03.png
// module id = hp35
// module chunks = 10